<template>
    <div class="shareImg">
        <Header title="分享图片" :show-back="true"/>
        <div class="shareImg-wrapper"><img src="../../assets/img/shareImg.jpg" alt=""/></div>
    </div>
</template>

<script>
    import Header from "../../components/header";
    import {Dialog} from 'vant';

    export default {
        components: {
            Header
        },
        created() {
            Dialog({message: '请截图保存您的海报'});
        }

    }
</script>

<style lang="scss">
    .shareImg {
        height: 100vh;

        &-wrapper {
            width: 100%;
        }
    }
</style>
